import * as Yup from 'yup';

import { FULL_NAME_REGEX } from '@utils/constants';

const validationSchema = Yup.object().shape({
  name: Yup.string().matches(FULL_NAME_REGEX, 'Please enter a full name'),
  email: Yup.string().email('Invalid email format'),
});

export default validationSchema;
